import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './store';
import { NotificationStack } from './components/NotificationStack/NotificationStack';
import { GlobalErrorBoundary } from './components/ErrorComponent/GlobalErrorBoundary';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';
import { setIsLoggedIn, setUserSettings } from './state/userSlice';
import { getUserSettings } from './repository/userRepository';
import { showFailure } from './components/NotificationStack/notificationSlice';
import { getDefaultUserSettings } from './models/UserSettings';
import { ThemeWrapper } from './components/Theme/ThemeWrapper';
import { LOCAL_STORAGE_THEME_KEY } from './models/Common';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

onAuthStateChanged(auth, async (user) => {
  if (user) {
    const tokenResult = await user.getIdTokenResult();

    store.dispatch(setIsLoggedIn({
      isAdmin: !!tokenResult.claims.admin,
      isContributor: !!tokenResult.claims.contributor,
      isLoggedIn: true,
      loggedInUserId: user.uid
    }));

    getUserSettings()
      .then((result) => {
        store.dispatch(setUserSettings(result));
      })
      .catch((e) => {
        showFailure("Error fetching user settings");
      });
  } else {
    store.dispatch(setIsLoggedIn({
      isAdmin: false,
      isContributor: false,
      isLoggedIn: false,
      loggedInUserId: ""
    }));

    store.dispatch(setUserSettings(getDefaultUserSettings()));
  }
});

const isDarkModeString = localStorage.getItem(LOCAL_STORAGE_THEME_KEY) ?? "false";
const html = document.querySelector("html");
html?.setAttribute("data-theme", isDarkModeString === "true" ? "dark" : "light");

root.render(
  <React.StrictMode>
    <GlobalErrorBoundary>
      <Provider store={store}>
        <ThemeWrapper>
          <NotificationStack />
          <App />
        </ThemeWrapper>
      </Provider>
    </GlobalErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
